import { isIOS } from "react-device-detect";

import { Bank } from "shared/constants/banks";

import { IbanAccount } from "store/features/ibanAccountSlice";
import { IbanInvoice } from "store/features/ibanInvoiceSlice";

export const PAYER_NAME_TOKEN = "{{ім'я та прізвище клієнта}}";
export const ORDER_NUMBER_TOKEN = "{{номер замовлення}}";

export const PAYMENT_PURPOSE_MAX_LENGTH = 140;

export const appendToken = (base: string, token: string) =>
  base + (base.length > 0 && !base.endsWith(";") ? ";" : "") + token;

export const removeToken = (base: string, token: string) =>
  base
    .replaceAll(";" + token, "")
    .replaceAll(token, "")
    .trim();

export const removeTokens = (base: string, tokens: string[]) =>
  tokens.reduce(removeToken, base);

export const substitutePaymentPurposeTokens = (
  template: string,
  payerFullName?: string,
  orderNumber?: string,
): string => {
  let result = template;
  result = result.replaceAll(PAYER_NAME_TOKEN, payerFullName?.trim() || "");

  result = result.replaceAll(ORDER_NUMBER_TOKEN, orderNumber?.trim() || "");

  return result;
};

export const newAccountOption = {
  label: "Нові реквізити",
  value: "new",
  item: null,
};

export const constructBankUrlIOS = (bank: Bank, paymentUrl: string) => {
  const { universalLinkIOS, packageIOS } = bank;

  if (!universalLinkIOS && !packageIOS) {
    return "";
  }

  if (universalLinkIOS) {
    const url = paymentUrl.replace("https://bank.gov.ua", universalLinkIOS);

    return url;
  }

  return paymentUrl.replace("https", packageIOS);
};

export const constructBankUrlAndroid = (bank: Bank, paymentUrl: string) => {
  const bankPackage = bank.packageAndroid;

  return (
    paymentUrl.replace("https", "intent") +
    `#Intent;scheme=https;package=${bankPackage};end`
  );
};

export const constructBankUrl = (bank: Bank, paymentUrl?: string) => {
  if (!paymentUrl) {
    return "";
  }

  return isIOS
    ? constructBankUrlIOS(bank, paymentUrl)
    : constructBankUrlAndroid(bank, paymentUrl);
};

export const constructPaymentUrl = (paymentUrl: string) => {
  const url = isIOS
    ? paymentUrl || ""
    : (paymentUrl || "").replace("https", "intent") +
      `#Intent;scheme=https;end`;

  return url;
};

export const constructBankAccountOptions = (accounts?: IbanAccount[]) => {
  if (!accounts?.length) {
    return [];
  }

  const options = accounts.map((account) => ({
    label: account.organizationName,
    value: account.ibanAccountUid,
    item: account,
  }));

  return options;
};

export const getSelectedIbanAccount = (
  invoice?: IbanInvoice | null,
  accounts?: IbanAccount[],
  preferredAccountUid?: string | null,
): IbanAccount | undefined => {
  if (invoice) {
    const matched = invoice?.ibanAccountUid
      ? accounts?.find((acc) => acc.ibanAccountUid === invoice?.ibanAccountUid)
      : undefined;

    if (matched) return matched;

    return {
      id: "new",
      ibanAccountUid: "new",
      organizationName: invoice.organizationName,
      identificationCode: invoice.identificationCode,
      iban: invoice.iban,
      publicName: invoice.publicName,
      isSuspended: false,
      bank: {
        bankId: 0,
        name: "",
        mfoCode: "",
      },
    };
  }

  if (preferredAccountUid) {
    const matched = accounts?.find(
      (acc) => acc.ibanAccountUid === preferredAccountUid,
    );

    if (matched) return matched;
  }

  return accounts?.[0];
};
